export const stackedVertical = (props: any = {}, data: any = {}) => {

    const legendOptions: any = {
        show: props.showLegend
    };

    if (props.legendPosition === 'bottom') {
        legendOptions[ 'bottom' ] = 0;
    } else if (props.legendPosition === 'left') {
        legendOptions[ 'left' ] = 0;
        legendOptions[ 'top' ] = 'center';
        legendOptions[ 'orient' ] = 'vertical';
    } else if (props.legendPosition === 'right') {
        legendOptions[ 'right' ] = 0;
        legendOptions[ 'top' ] = 'center';
        legendOptions[ 'orient' ] = 'vertical';
    }

    return {
        xAxis: {
            type: 'category',
            data: data.titles || []
        },
        tooltip: {
            formatter: `{a}:<br>${props.prefix ? props.prefix : ''}{c}${props.suffix ? props.suffix : ''}`,
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
        },
        yAxis: {
            type: 'value',
            boundaryGap: [ 0, 0.01 ],
            splitLine: {
                show: props.showGridlines
            },
            axisLabel: {
                formatter: `${props.prefix ? props.prefix : ''}{value}${props.suffix ? props.suffix : ''}`
            }
        },
        title: {
            text: props.title,
            show: !!props.title,
            textStyle: {
                fontSize: Number(props?.fontSize),
                color: props?.color,
                fontFamily: props.fontFamily,
            }
        },
        textStyle: {
            color: props.color,
            fontFamily: props.fontFamily,
        },
        series: data.series || [],
        legend: legendOptions,
        label: {
            show: props.showAnnotation,
            position: props.insideAnnotation ? 'inside' : 'top',
            formatter: `${props.prefix ? props.prefix : ''}{c}${props.suffix ? props.suffix : ''}`
        }
    }
}